export default __webpack_public_path__ + "static/media/logo-beta.b5f8fde9.png";